import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isMusicEnabled, onMusicChange, toggleMusic } from "@/lib/ambient-music";

export default function MusicToggle({ className = "" }) {
  const [on, setOn] = useState(isMusicEnabled());
  useEffect(() => onMusicChange(setOn), []);
  return (
    <button
      type="button"
      onClick={toggleMusic}
      aria-label={on ? "Turn background music off" : "Turn background music on"}
      aria-pressed={on}
      className={`tap-scale p-2 rounded-full text-slate-400 hover:text-amber-400 hover:bg-white/5 transition-colors ${className}`}
      data-testid="music-toggle"
    >
      {on ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
    </button>
  );
}
